import {NgModule} from '@angular/core';
import {MenuComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {CommonModule} from '@angular/common';
import {DirectivesModule} from 'app/core/directives/directives.module';
import {AvatarComponentModule} from 'app/components/ui/avatar/item.module';
import {IconComponentModule} from 'app/components/ui/icon/item.module';
import {ButtonComponentModule} from 'app/components/ui/button/item.module';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    DirectivesModule,
    AvatarComponentModule,
    IconComponentModule,
    ButtonComponentModule,
  ],
  exports: [
    MenuComponent
  ],
  declarations: [MenuComponent],
  providers: [],
})
export class MenuComponentModule {
}
